// extracted by mini-css-extract-plugin
export var aircallIframe = "_l0-3";
export var fabContainer = "_l0-5";
export var fabRinging = "_l0-6";
export var loadingOverlay = "_l0-4";
export var pulse = "_l0-7";
export var widgetContent = "_l0-2";
export var widgetPanel = "_l0-0";
export var widgetPanelExpanded = "_l0-1";